export enum ErpRoles {
    ERP_ADMIN = 'ERP_UI_ADMIN_USER',
}
